import React from 'react';
import { connect } from 'react-redux';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import { Collapsible, CollapsibleContent, CollapsibleHeader } from '@fiverr-private/disclosure';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Avatar, AvatarImage } from '@fiverr-private/avatar';
import withImpressions from '../../../shared/hoc/withImpressions';
import Description from '../../../shared/Description';
import useTranslation from '../../../shared/hooks/useTranslation';
import { impressionConfig, getNewCommentLength } from '../../../shared/ResponseItem/utils';
import { shouldDisplayTranslation } from '../../../../utils/translation';
import useMedia from '../../../shared/hooks/useMedia';
import TranslationButton from '../../../shared/TranslationButton';
import './styles.scss';

const componentName = 'seller_review_response';
const COMPONENT_CLASS = 'review_seller_comment_is_shown';

const SellerResponse = ({ response = {}, ratingScore, sellerUsername = '', sellerImage }) => {
    const context = getContext();
    const { locale } = context;
    const { comment: originalText, comment_language: sourceLanguage } = response;
    const displayTranslationButton = shouldDisplayTranslation(locale, sourceLanguage);
    const { translationConfig, text } = useTranslation(originalText, sourceLanguage);
    const isSmallScreen = useMedia();

    return (
        <Container paddingY={isSmallScreen ? '3' : '4'}>
            <Collapsible chevronSize={isSmallScreen ? 'sm' : 'md'} defaultExpanded={ratingScore < 4}>
                <CollapsibleHeader padding="5px 0">
                    <Stack alignItems="center" gap="2">
                        <Avatar size="sm" username={sellerUsername}>
                            {sellerImage ? <AvatarImage alt="image-docs" src={sellerImage} /> : null}
                        </Avatar>
                        <Text fontWeight="bold" size="b_sm">
                            <I18n k={'reviews.users.show.seller_response'} />
                        </Text>
                    </Stack>
                </CollapsibleHeader>
                <CollapsibleContent>
                    <Container paddingLeft="10">
                        <Description text={text} className="m-b-0" maxLength={getNewCommentLength()} displayLess />
                        {displayTranslationButton ? (
                            <Container marginTop="3">
                                <TranslationButton
                                    translationConfig={translationConfig}
                                    componentName={componentName}
                                />
                            </Container>
                        ) : null}
                    </Container>
                </CollapsibleContent>
            </Collapsible>
        </Container>
    );
};

const mapStateToProps = ({ seller_username, seller_img_url }) => ({
    sellerUsername: seller_username,
    sellerImage: seller_img_url,
});

export default connect(mapStateToProps)(withImpressions(SellerResponse, impressionConfig(COMPONENT_CLASS)));
